module.exports = __webpack_public_path__ + "img/ctrl-ry-stub-mid--.807765aa.svg";